import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import useHasAccessToFieldSharing from '../../../../hooks/useHasAccessToFieldSharing';
import { AppState } from '../../../../types/AppState';
import AgencyShareChatButton from '../../../AgencyShareChat/AgencyShareChatButton';
import CopyAllButton from '../../../CopyAllButton';
import ShareEvent from '../../../ShareEvent/ShareEvent';
import CollapseButton from '../CollapseButton';
import { EVENT_PANE_MARGIN } from '../EventPane.styles';
import { CloseButton } from './CloseButton';
import { CollapsedHeaderData } from './CollapsedHeaderData/CollapsedHeaderData';
import { ExpandedHeaderData } from './ExpandedHeaderData';

export const StyledHeader = styled(Box).attrs({
  position: 'relative',
  margin: `${EVENT_PANE_MARGIN}px ${EVENT_PANE_MARGIN}px 0`,
})``;

export const StyledCallerID = styled(Text).attrs({
  color: 'panePrimaryText',
  fontWeight: 'bold',
})``;

export const StyledSource = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
})``;

interface EventPaneHeaderProps {
  callerID: string;
  source: string;
  timestamp: number;
  recentTranscriptionsCount?: number;
  onCallerIdClick?: () => void;
  onClose: () => void;
}

const EventPaneHeader = ({
  callerID,
  source,
  timestamp,
  recentTranscriptionsCount = 0,
  onCallerIdClick,
  onClose = () => null,
}: EventPaneHeaderProps) => {
  const showFieldSharing = useHasAccessToFieldSharing();
  const isCollapsed = useSelector(
    (state: AppState) => state.eventPane.isCollapsed,
  );

  return (
    <StyledHeader data-name="event-pane-header">
      <Box horizontal justify="space-between">
        {isCollapsed && (
          <CollapsedHeaderData
            callerID={callerID}
            timestamp={timestamp}
            recentTranscriptionsCount={recentTranscriptionsCount}
            onCallerIdClick={onCallerIdClick}
          />
        )}
        {!isCollapsed && (
          <ExpandedHeaderData
            callerID={callerID}
            timestamp={timestamp}
            source={source}
            recentTranscriptionsCount={recentTranscriptionsCount}
            onCallerIdClick={onCallerIdClick}
          />
        )}
        <Box data-name="event-pane-tools" height={20} horizontal align="center">
          {showFieldSharing ? (
            <ShareEvent isLabelHidden={isCollapsed} />
          ) : (
            <AgencyShareChatButton />
          )}
          <CopyAllButton isLabelHidden={isCollapsed} />
          <CollapseButton isLabelHidden={isCollapsed} />
          <CloseButton isLabelHidden={isCollapsed} onClick={onClose} />
        </Box>
      </Box>
    </StyledHeader>
  );
};

export default EventPaneHeader;
